import Button from '@mui/material/Button'
import CircularProgress  from '@mui/material/CircularProgress'
import './green_button.scss'
import {CSSProperties}from 'react'
interface iStyle { [key:string]:string}
interface iProps {label:string,fun:Function,children?:any
    ,disabled?:boolean,loading?:boolean,fullWidth?:boolean,style?:CSSProperties
}

export default function GreenButton ({label,fun,children,disabled=false,loading,fullWidth,style}:iProps) {

    return (
        // <Button className="GreenButtonContainer add"
        // disabled={loading || disabled}
        // sx={{
        //     background:'var(--primary-color)',
       
        //     '& .text': {
        //         color:'white',
        //         fontSize:'0.899rem'
        //     },
        //     '& :hover':{
        //         backgroundColor:'#1ABC9C',
                
        //     }
           
        // }}
        // fullWidth={fullWidth}
    
        // onClick={()=>fun()}>
        //     {loading?
        //     <CircularProgress size='1rem' />:
        //         <>
        //             <span className='text'>{label} </span>
        //             <span className="children">{children}</span>
        //         </>
        //     }
        

        // </Button>
   

       
            <button className=" addButton"
            disabled={loading || disabled}
            style={{...style}}
        
            onClick={()=>fun()}>
                {loading?
                <CircularProgress size='1rem' />:
                    <>
                        <div className='text'>{label} </div>
                        <span className="children">{children}</span>
                    </>
                }
            

            </button>
   
    )
}